<script setup lang="ts">
  // SEE: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/dialog#usage_notes
  // 브라우저 내장 dialog api 사용
  // 표시 : [모달ID].showModal(), 숨김 : [모달ID].close()

  interface Props {
    /** 모달 ID : 유니크 해야함 */
    id: string;

    isVisible?: boolean;

    /** 모달 밖을 클릭했을 때 닫히게? */
    isBackdrop?: boolean;

    isBottomOnMobile?: boolean;

    hasCloseX?: boolean;

    confirmText?: string;

    cancelText?: string;

    title?: string;

    message?: string;
  }

  withDefaults(defineProps<Props>(), {
    isVisible: false,
    confirmText: '',
    cancelText: '',
    title: '',
    message: '',
  });

  const emit = defineEmits<{
    (e: 'cancel'): void;
    (e: 'confirm'): void;
    (e: 'close'): void;
  }>();

  function handleCancel() {
    emit('cancel');
    emit('close');
  }

  function handleConfirm() {
    emit('confirm');
    emit('close');
  }
</script>

<template>
  <dialog
    :id="id"
    :open="isVisible"
    :class="[
      'modal',
      {
        'modal-open': isVisible,
        'modal-bottom': isBottomOnMobile,
        'sm:modal-middle': isBottomOnMobile,
      },
    ]">
    <div class="modal-box md:max-w-md">
      <h3
        v-if="Boolean(title)"
        class="text-lg font-bold">
        {{ title }}
      </h3>
      <div
        v-if="Boolean(message)"
        class="py-4">
        {{ message }}
      </div>

      <slot />

      <form method="dialog">
        <button
          v-if="hasCloseX"
          class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
          @click="handleCancel">
          ✕
        </button>

        <slot name="action">
          <div class="text-right">
            <button
              v-if="Boolean(cancelText)"
              class="btn btn-error btn-outline"
              @click="handleCancel">
              {{ cancelText }}
            </button>
            <button
              v-if="Boolean(confirmText)"
              class="btn btn-primary ml-2"
              @click="handleConfirm">
              {{ confirmText }}
            </button>
          </div>
        </slot>
      </form>
    </div>

    <form
      v-if="isBackdrop"
      method="dialog"
      class="modal-backdrop">
      <button @click="handleCancel">close</button>
    </form>
  </dialog>
</template>
